const isoToday = () => new Date().toISOString().slice(0, 10);

export const FONDO_DEFAULT_OWNER = {
  roleMode: "eigandi",
  kennitala: "5212161310",
  name: "FONDO ehf.",
  address: "Pósthólf 9007",
  postalCode: "109",
  city: "Reykjavík",
  phone: "8923392",
  email: "fondo@fondo.is",
  nationality: "Ísland",
  isDeceased: false,
  isPoliticallyExposed: false,
  banki: "",
  hofudbok: "",
  reikningur: "",
  dueDiligenceNote: "",
  hasSecondarySigner: true,
  secondarySigner: {
    kennitala: "1306862069",
    name: "Javier E Olguin Sepulveda",
    phone: "8923392",
    email: "fondo@fondo.is",
  },
  createOwnerNotification: false,
};

export const COUNTRY_OPTIONS = ["Ísland", "Danmörk", "Svíþjóð", "Noregur", "Pólland", "Annað"];

export const INSURANCE_OPTIONS = [
  "",
  "Sjóvá",
  "TM tryggingar",
  "VÍS tryggingar",
  "Vörður tryggingar",
  "Eftirvagn/tengitæki á tryggingu ökutækis",
  "Úr umferð",
];

export const FINANCING_SOURCE_OPTIONS = [
  "",
  "Laun",
  "Lán",
  "Arður",
  "Arfur",
  "Fjármagnstekjur",
  "Rekstrartekjur",
];

export const ACCESSORY_FIELDS = [
  { key: "sumardekk", label: "Sumardekk" },
  { key: "heilsarsdekk", label: "Heilsársdekk" },
  { key: "vetrardekk", label: "Vetrardekk" },
  { key: "nagladekk", label: "Nagladekk" },
  { key: "farangursgrind", label: "Farangursgrind" },
  { key: "skidabogar", label: "Skíðabogar" },
  { key: "hjolmateki", label: "Hjólmatæki" },
];

export const ATTACHMENT_FIELDS = [
  { key: "registrationCertificate", label: "Skráningarskírteini" },
  { key: "inspectionReport", label: "Ferilskrá" },
  { key: "serviceBook", label: "Þjónustubók" },
  { key: "ownerManual", label: "Eigendahandbók" },
  { key: "skiBox", label: "Skóðunarnvottorð" },
  { key: "debtAndInsuranceCertificate", label: "Skulda- & vátryggingastaða" },
  { key: "lubricationBook", label: "Smurbók" },
];

export const createEmptyParty = (roleMode = "eigandi") => ({
  roleMode,
  kennitala: "",
  name: "",
  address: "",
  postalCode: "",
  city: "",
  phone: "",
  email: "",
  nationality: "Ísland",
  isDeceased: false,
  isPoliticallyExposed: false,
  banki: "",
  hofudbok: "",
  reikningur: "",
  dueDiligenceNote: "",
  hasSecondarySigner: false,
  secondarySigner: {
    kennitala: "",
    name: "",
    phone: "",
    email: "",
  },
  createOwnerNotification: false,
});

export const createDefaultAfsolForm = (createdBy = "") => ({
  general: {
    referenceNumber: "",
    afsalDate: isoToday(),
    placeOfSale: "Reykjavík",
    createdBy,
    comments: "",
    loanId: "",
    loanNumber: "",
  },
  vehicle: {
    manufacturer: "",
    model: "",
    displayName: "",
    fastanumer: "",
    registrationNumber: "",
    vin: "",
    firstRegistration: "",
    modelYear: "",
    productionYear: "",
    nextInspection: "",
    lastInspection: "",
    mileage: "",
    mileageUnit: "km.",
    keysWithRemote: "0",
    keysWithoutRemote: "0",
    isNewVehicle: false,
    isVatVehicle: false,
    continueLeasing: false,
  },
  condition: {
    temporaryRegistered: false,
    timingBeltChanged: false,
    timingBeltMileage: "",
    oilLeak: false,
    oilBurn: false,
    coolantLeak: false,
    majorDamage: false,
    buyerInspected: false,
    conditionComments: "",
    additionalInfo: "Upplýsingar um fyrsta skráningardag liggja ekki fyrir.",
  },
  accessories: {
    sumardekk: false,
    heilsarsdekk: false,
    vetrardekk: false,
    nagladekk: false,
    farangursgrind: false,
    skidabogar: false,
    hjolmateki: false,
    notes: "Varahjól, lyftari og felgulykill er fast fylgifé með bifreið hafi það fylgt með henni þegar hún var ný.",
  },
  insurance: {
    sellerInsurer: "",
    buyerInsurer: "",
    liabilityInsurance: true,
    cascoInsurance: false,
    selfRisk: "",
  },
  warranties: {
    brokerWarrantyValidUntil: "",
    brokerWarrantyValidKm: "",
    rustWarrantyEveryKm: "",
    otherWarranties: "",
  },
  taxes: {
    vehicleTaxPaid: false,
    weightTaxPaid: false,
    debtCollectionFee: false,
    sellerVehicleTax: "0",
    sellerWeightTax: "0",
    buyerVehicleTax: "0",
    buyerWeightTax: "0",
  },
  attachments: {
    registrationCertificate: false,
    inspectionReport: false,
    serviceBook: false,
    ownerManual: false,
    skiBox: false,
    debtAndInsuranceCertificate: false,
    lubricationBook: false,
    webhandoverCompleted: false,
    webhandoverDate: isoToday(),
  },
  payment: {
    purchasePrice: "",
    breakdown: [],
    comments: "",
    sellerFinancingNotes: [],
    buyerFinancingNotes: [],
  },
  seller: {
    owner: { ...FONDO_DEFAULT_OWNER },
    coOwner: createEmptyParty("medeigandi"),
    keeper: createEmptyParty("umradamadur"),
  },
  buyer: {
    owner: createEmptyParty("eigandi"),
    coOwner: createEmptyParty("medeigandi"),
    keeper: createEmptyParty("umradamadur"),
  },
});

const isObject = (value) => value && typeof value === "object" && !Array.isArray(value);

export const mergeDeep = (base, override) => {
  if (Array.isArray(base)) {
    return Array.isArray(override) ? override : base;
  }

  const merged = { ...base };
  Object.entries(override || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      merged[key] = value;
    } else if (isObject(value) && isObject(base?.[key])) {
      merged[key] = mergeDeep(base[key], value);
    } else {
      merged[key] = value;
    }
  });
  return merged;
};

export const hydrateAfsolForm = (savedForm, createdBy = "") => mergeDeep(createDefaultAfsolForm(createdBy), savedForm || {});

export const normalizeIsoDate = (value) => {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

  const dotMatch = value.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (dotMatch) {
    const [, day, month, year] = dotMatch;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
};

export const splitVehicleLabel = (label = "") => {
  const trimmed = label.trim();
  if (!trimmed) return { manufacturer: "", model: "" };
  const [manufacturer, ...rest] = trimmed.split(/\s+/);
  return {
    manufacturer: manufacturer || "",
    model: rest.join(" "),
  };
};

// Map Creditinfo insurance company name to our dropdown options
const matchInsurer = (apiName) => {
  if (!apiName) return "";
  const lower = apiName.toLowerCase();
  if (lower.includes("sjóvá") || lower.includes("sjova")) return "Sjóvá";
  if (lower.includes("tm ") || lower.includes("tm-") || lower.includes("tryggingamiðstöð") || lower.includes("tryggingamidstod")) return "TM tryggingar";
  if (lower.includes("vís") || lower.includes("vis")) return "VÍS tryggingar";
  if (lower.includes("vörður") || lower.includes("vordur")) return "Vörður tryggingar";
  return apiName; // return raw if no match
};

export const applyVehicleLookupToForm = (form, vehicleResponse, dealType = "") => {
  const displayName = vehicleResponse?.tegund || vehicleResponse?.vehicle_type || "";
  const subtype = vehicleResponse?.undirtegund || "";
  const vehicleParts = splitVehicleLabel(displayName);

  // Extract first (current) owner
  const owners = vehicleResponse?.owners || [];
  const currentOwner = owners.length > 0 ? owners[0] : null;

  // Map insurance company to dropdown value
  const mappedInsurer = matchInsurer(vehicleResponse?.insurance_company);

  const updated = {
    ...form,
    vehicle: {
      ...form.vehicle,
      fastanumer: vehicleResponse?.fastanumer || form.vehicle.fastanumer,
      registrationNumber: vehicleResponse?.fastanumer || form.vehicle.registrationNumber,
      displayName: displayName || form.vehicle.displayName,
      subtype: subtype || form.vehicle.subtype || "",
      manufacturer: vehicleResponse?.tegund || form.vehicle.manufacturer || vehicleParts.manufacturer,
      model: subtype || form.vehicle.model || vehicleParts.model,
      firstRegistration: form.vehicle.firstRegistration || normalizeIsoDate(vehicleResponse?.fyrsta_skraning || vehicleResponse?.first_registration_date),
      color: vehicleResponse?.color || form.vehicle.color || "",
      productionYear: vehicleResponse?.production_year || form.vehicle.productionYear || "",
      modelYear: normalizeIsoDate(vehicleResponse?.fyrsta_skraning || vehicleResponse?.first_registration_date) || form.vehicle.modelYear || "",
      vin: vehicleResponse?.vin || form.vehicle.vin || "",
      ownerName: currentOwner?.name || form.vehicle.ownerName || "",
      ownerKennitala: currentOwner?.regno || form.vehicle.ownerKennitala || "",
      mileage: form.vehicle.mileage || (vehicleResponse?.latest_mileage ? String(vehicleResponse.latest_mileage) : ""),
      mileageSource: vehicleResponse?.latest_mileage ? "creditinfo" : form.vehicle.mileageSource || "",
    },
    insurance: {
      ...form.insurance,
      sellerInsurer: mappedInsurer || form.insurance?.sellerInsurer || "",
    },
    // Store full vehicle lookup data for Ferilskrá page
    vehicleLookupData: vehicleResponse || form.vehicleLookupData || null,
  };

  // Auto-fill seller party with vehicle owner when FONDO is buying
  if (dealType === "kaupa" && currentOwner?.name) {
    updated.seller = {
      ...updated.seller,
      owner: {
        ...updated.seller.owner,
        name: updated.seller.owner.name || currentOwner.name,
        kennitala: updated.seller.owner.kennitala || currentOwner.regno || "",
        address: updated.seller.owner.address || currentOwner.address || "",
        postalCode: updated.seller.owner.postalCode || currentOwner.postalCode || "",
        city: updated.seller.owner.city || currentOwner.city || "",
      },
    };
  }

  return updated;
};

export const applyLoanToAfsolForm = (form, loan) => {
  if (!loan) return form;

  const split = splitVehicleLabel(loan.vehicle_type || "");

  return {
    ...form,
    general: {
      ...form.general,
      loanId: loan.id || form.general.loanId,
      loanNumber: loan.loan_number || form.general.loanNumber,
    },
    vehicle: {
      ...form.vehicle,
      fastanumer: form.vehicle.fastanumer || loan.registration_number || "",
      registrationNumber: form.vehicle.registrationNumber || loan.registration_number || "",
      displayName: form.vehicle.displayName || loan.vehicle_type || "",
      manufacturer: form.vehicle.manufacturer || split.manufacturer,
      model: form.vehicle.model || split.model,
      firstRegistration: form.vehicle.firstRegistration || loan.first_registration_date || "",
    },
    payment: {
      ...form.payment,
      purchasePrice: form.payment.purchasePrice || (() => {
        if (loan.purchase_price) {
          const netto = loan.purchase_price - (loan.lantokugjald || loan.origination_fee || 0);
          return String(Math.round(netto));
        }
        if (loan.loan_amount) {
          const netto = loan.loan_amount - (loan.lantokugjald || loan.origination_fee || 0);
          return String(Math.round(netto));
        }
        return "";
      })(),
      breakdown: (() => {
        const items = [...(form.payment.breakdown || [])];
        if (loan.loan_amount) {
          items.push({ category: "fjarmoegnun", label: "FONDO", amount: String(Math.round(loan.loan_amount)), comment: "", fastanumer: "" });
        }
        if (loan.deposit) {
          items.push({ category: "greidsla", label: "Millifærsla", amount: String(Math.round(loan.deposit)), comment: "", fastanumer: "" });
        }
        return items;
      })(),
    },
    buyer: {
      ...form.buyer,
      owner: {
        ...form.buyer.owner,
        kennitala: form.buyer.owner.kennitala || loan.borrower_info?.ssn || "",
        name: form.buyer.owner.name || loan.borrower_info?.full_name || "",
        address: form.buyer.owner.address || loan.borrower_info?.address || "",
        postalCode: form.buyer.owner.postalCode || loan.borrower_info?.zip_code || "",
        city: form.buyer.owner.city || loan.borrower_info?.city || "",
        phone: form.buyer.owner.phone || loan.borrower_info?.phone || "",
        email: form.buyer.owner.email || loan.borrower_info?.email || "",
      },
    },
  };
};

export const personLookupToPartyFields = (data, existingParty) => ({
  ...existingParty,
  name: data?.name || existingParty.name,
  address: data?.address || existingParty.address,
  postalCode: data?.postal_code || data?.postalCode || existingParty.postalCode,
  city: data?.city || existingParty.city,
  phone: data?.phone ? data.phone.replace("+354", "") : existingParty.phone,
  email: data?.email || existingParty.email,
});

export const formatReferenceNumber = (referenceNumber) => {
  if (!referenceNumber) return "Óvistað";
  return `Afsal nr. ${String(referenceNumber).padStart(4, "0")}`;
};

export const normalizeFinancingSources = (value) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    if (value.every((item) => typeof item === "string")) {
      return value.filter(Boolean);
    }

    return value
      .flatMap((item) => {
        if (typeof item === "string") return item ? [item] : [];
        if (item?.source) return [item.source];
        if (Array.isArray(item?.sources)) return item.sources.filter(Boolean);
        return [];
      })
      .filter(Boolean);
  }

  if (typeof value === "string") {
    return value ? [value] : [];
  }

  if (Array.isArray(value?.sources)) {
    return value.sources.filter(Boolean);
  }

  if (value?.source) {
    return [value.source];
  }

  return [];
};
